module.exports = __webpack_public_path__ + "static/media/collection-all-cases.d4a818ec.svg";